import ImagesData from './images';

export const EvidenceData = [
  {
    'id': 'all',
    'section': 'Todas',
    'route': '/evidencias/todas',
    'content': []
  },
  {
    'id': 'ux',
    'section': 'UI/UX',
    'route': '/evidencias/ux',
    'content': [
      {
        'image': ImagesData.hub,
        'client': 'Infosel',
        'project': 'Infosel Hub',
        'product': 'App híbrida',
        'intro': 'Aplicación financiera (iOS & Android) orientada al trading online.',
        'activity': [
          'UX Research.',
          'Design System.',
          'Diseño de interfaz de usuario.',
          'Prototipado.'
        ]
      },
      {
        'image': ImagesData.bbb,
        'client': 'dgk',
        'project': 'Bed Bath & Beyond México',
        'product': 'App híbrida',
        'intro': 'Aplicación e-commerce (iOS & Android) orientada al consumo de productos para el hogar.',
        'activity': [
          'UX Research.',
          'Design System.',
          'Diseño de interfaz de usuario.',
          'Prototipado.'
        ]
      },
      {
        'image': ImagesData.dinny,
        'client': 'IA interactive®',
        'project': 'Dinny®',
        'product': 'App híbrida',
        'intro': 'Aplicación delivery (iOS & Android) orientada al consumo de alimentos.',
        'activity': [
          'Diseño de interfaz de usuario.',
          'Prototipado.'
        ]
      },
      {
        'image': ImagesData.fixntic,
        'client': 'Fixntic',
        'project': 'Fixntic',
        'product': 'app web',
        'intro': 'Sitio Web con catálogo de servicios informaticos y soporte de ordenadores.',
        'activity': [
          'Diseño de interfaz de usuario.'
        ]
      }
    ]
  },
  {
    'id': 'creative',
    'section': 'Dirección Creativa',
    'route': '/evidencias/creativa',
    'content': [
      {
        'image': ImagesData.cuentos,
        'client': 'UMSNH',
        'project': 'Diez Cuentos de Hans Christian Andersen en Purépecha',
        'product': 'Libro',
        'intro': 'Producto editorial que reune 10 cuentos ilustrados y traducidos al idioma purépecha.',
        'activity': [
          'Dirección Creativa',
          'Diseño de maqueta',
          'Pre y Post prensa'
        ]
      }
    ]
  },
  {
    'id': 'branding',
    'section': 'Branding',
    'route': '/evidencias/branding',
    'content': [
      {
        'image': ImagesData.nubela,
        'client': 'Saludable',
        'project': 'Clínica Nubela',
        'product': 'Rebranding',
        'intro': 'Gesitón de toda la identidad visual de consultorios de servicios de cuidado estético.',
        'activity': [
          'Naming',
          'Diseño de identidad',
          'Diseño de aplicaciones',
          'Asesoría para registro de marca'
        ]
      }
    ]
  },
  {
    'id': 'frontend',
    'section': 'Frontend',
    'route': '/evidencias/frontend',
    'content': [
      {
        'image': ImagesData.rs,
        'client': 'RS Viajes',
        'project': 'Micrositio Franquicias',
        'product': 'WEB',
        'intro': 'Micrositio para promoción e información para adquirir una franquicia de agencia de viajes.',
        'activity': [
          'Diseño de interfaz',
          'Frontend'
        ]
      }
    ]
  }
];
